<template>
  <CategoryForm
    :breadcrumbs="breadcrumbs"
    :value="{...defaultNew, categoryItems: []}"
  >
    <template #actions="{form, fields}">
      <v-btn
        :disabled="!form"
        color="success"
        class="mx-2"
        rounded
        @click="create(fields)"
      >
        Create
      </v-btn>
    </template>
  </CategoryForm>
</template>

<script>
import CategoryForm from '@/pages/App/MenuCreator/Categories/__CategoryForm__'
import { Category } from '@/store/models'
import { mapGetters } from 'vuex'
import createMixin from '@/mixins/apiCreateMixin'

export default {
  name: 'CategoryNew',
  components: { CategoryForm },
  mixins: [createMixin(Category)],
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Categories',
          exact: true,
          to: { name: 'App-MenuCreator-Categories' }
        },
        {
          text: 'New',
          exact: true,
          to: { name: 'App-MenuCreator-Categories-New' }
        }
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['defaultNew'])
  }
}
</script>
